module.exports = [
	{
		"name": "Suikoden Microsite",
		"client": "Konami Digital Entertainment",
		"alt": "",
		"website": "",
		"body": "Label was proud to be tapped by Konami and Catch & Release Media to create a microsite for the release of <i>Suikoden</i> the popular role-playing game for Nintendo Wii. Designed using assets from the video game, the website featured screenshots, character descriptions, and purchasing information.",
		"id": 1,
		"featured": false,
		"src": [
			"suikoden_port_lg.jpg",
			"detail_suikoden_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"Information Architecture",
			"Web Design",
			"Web Development"
		],
		"slug": "suikoden-microsite"
	},
	{
		"name": "Dark Blue Banner Campaign",
		"client": "Turner",
		"alt": "",
		"website": "",
		"body": "We created a variety of static and rich media banner ads to promote the new show Dark Blue.\n\nAt Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 2,
		"featured": false,
		"src": [
			"dark_blue_hero.jpg",
			"detail_darkblue_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Banner design",
			"Banner Development (Static & Rich Media)",
			"Takeovers/Roadblocks"
		],
		"slug": "dark-blue-banner-campaign"
	},
	{
		"name": "Supermarket Mobile App",
		"client": "Village Super Market, Inc.",
		"alt": "Village Super Market",
		"website": "",
		"body": "Label was proud to produce a iOS and Android mobile app for the Village Super Market store. The mobile app is loaded with features to make food shopping easier:\n\nSave money with “Shop-Ons”, exclusive deals for mobile users. Preview upcoming offers, clip coupons and set reminders to cash in on active deals. Scan Shop-Ons at checkout right from your mobile device.\n\nOrder ahead with Roadside Pick-Up. Forget something, need a few items? Let us shop it for you. We’ll even bring it to you, no need to get out of the car!\n\nSave time waiting in line. Build and send your deli order anytime, anywhere. Skip the line; your order will be ready when you arrive.\n\nUse the app’s location feature to find a Village Super Market near you.\n\nBuild multiple shopping lists for every occasion from weekly shopping to birthday parties. Save and reuse your lists as often as you’d like!\n\nFollow our foodie experts for inside information on your Village Super Market.\n\nAsk the expert for real-time answers to your questions. Speak to the manager, baker, dietitian, pharmacist and more!",
		"id": 3,
		"featured": true,
		"src": [
			"detail_village_01.jpg",
			"detail_village_02.jpg"
		],
		"type": [
			"Apps",
			"All"
		],
		"bullets": [
			"Requirements",
			"Technical Function Specificiations",
			"Information Archecture",
			"Cross-Platform Mobile App Development"
		],
		"slug": "supermarket-mobile-app"
	},
	{
		"name": "Ping Pong-A-Thon",
		"client": "Alcone Marketing",
		"alt": "",
		"website": "",
		"body": "Chew up the competition in this fast-paced iOS and Android table tennis tournament app. The stadium’s packed, the crowd is cheering and we’re in gear to serve up a healthy dose of Fun! Think you have what it takes to beat your favorite One A Day® VitaCraves multivitamins? Better get on the ball, because these gummies for grown-ups are ready to show you what they’re made of. Come on, hit download and give it your best shot!",
		"id": 4,
		"featured": false,
		"src": [
			"pong_large.jpg",
			"detail_pingpong_02.jpg"
		],
		"type": [
			"Apps",
			"Games",
			"All"
		],
		"bullets": [
			"Requirements",
			"Technical & Functional Specifications",
			"Cross-Platform Mobile App Development",
			"App Store Publishing"
		],
		"slug": "ping-pong-a-thon"
	},
	{
		"name": "Ninjatown Banner Campaign",
		"client": "Shawnimals",
		"website": "",
		"id": 5,
		"featured": false,
		"body": "We created a variety of static and rich media banner ads to promote the Ninjatown mobile app for iPhone.\n\nAt Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"src": [
			"ninjatown_port_lg.jpg",
			"detail_ninjetownbanners_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Design",
			"Banner Development (Static & Rich Media)"
		],
		"slug": "ninjatown-banner-campaign"
	},
	{
		"name": "Ninjatown Ninja Builder",
		"client": "Shawnimals",
		"alt": "",
		"website": "",
		"body": "Ninjatown® Ninja Builder™ allows you to totally customize your very own ninja with a variety of body colors, accessories, foods, weapons, backgrounds and more! In fact, there are nearly one million combinations you can come up with. Once you’re done, save your creation and show it off to your friends via Twitter and Facebook, or simply export it to your photos to be used as a device background.",
		"id": 6,
		"featured": false,
		"src": [
			"ninja-builder.jpg",
			"detail_ninjetown_02.jpg"
		],
		"type": [
			"Apps",
			"All"
		],
		"bullets": [
			"Design",
			"Native iOS App Development",
			"Social Network Integration",
			"App Store Publishing"
		],
		"slug": "ninjatown-ninja-builder"
	},
	{
		"name": "Gillette VLR Web Development",
		"client": "ESPN.com",
		"alt": "",
		"website": "",
		"body": "The Gillette Virtual Locker Room allowed ESPN.com users to explore a virtual NFL locker room and enter a sweepstakes contest.",
		"id": 7,
		"featured": false,
		"src": [
			"gillette_lockerroom_port_lg.jpg",
			"detail_virtual_lockerroom_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML, Flash Development",
			"Enterprise System Integration"
		],
		"slug": "gillette-vlr-web-development"
	},
	{
		"name": "Target Terror Game and Banner Campaign",
		"client": "Konami",
		"alt": "",
		"body": "As part of their launch campaign for <i>Target: Terror for Wii</i>, Konami hired us to create a web-based \"microgame\".  Using art and sound assets original created for the console game, we created a web based first-person shooter which was featured on their website. In addition to developing the game, we created a variety of banners ads for their launch campaign.\n\nAt Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook. ",
		"website": "",
		"id": 8,
		"featured": false,
		"src": [
			"target_terror_port_lg.jpg",
			"detail_target_terror_02.jpg"
		],
		"type": [
			"Games",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML/Flash Development"
		],
		"slug": "target-terror-game-and-banner-campaign"
	},
	{
		"name": "ESPN Home Run Challenge and Banner Campaign",
		"client": "ESPN.com",
		"alt": "",
		"website": "",
		"body": "The Home Run Challenge allowed ESPN.com visitors to participate in an online batting contest to win prizes. All game assets, including 3D models, UI, and sound design, were created by Label.",
		"id": 10,
		"featured": false,
		"src": [
			"ESPN_home_run_port_lg.jpg",
			"detail_homerun_challenge_02.jpg"
		],
		"type": [
			"Games",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"Game Design",
			"3D Modeling and Animation",
			"Custom Sound Design",
			"HTML/Flash Development",
			"Legacy System Integration"
		],
		"slug": "espn-home-run-challenge-and-banner-campaign"
	},
	{
		"name": "The Beatles Rock Band Website",
		"client": "Harmonix",
		"alt": "",
		"website": "",
		"body": "The Beatles: Rock Band was the first band-centric game in the Rock Band series (Wii, PS, Xbox) and was centered on the popular English rock group. The game features virtual portrayals of the four band members performing the songs throughout the band's history, including depictions of some of their famous live performances, as well as a number of \"dreamscape\" sequences for songs from the Abbey Road Studios recording sessions during the group's studio years.\n\nWe're proud to have worked with Harmonix, the game developer, to design and develop a website which allowed fans to not only learn about the game but also get codes which they could then use to access extra songs within the game.\n",
		"id": 11,
		"featured": false,
		"src": [
			"detail_beatles_01.jpg",
			"detail_beatles_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"CSS/HTML/PHP"
		],
		"slug": "the-beatles-rock-band-website"
	},
	{
		"client": "Konami",
		"name": "Track and Field Banner Campaign",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 12,
		"featured": false,
		"src": [
			"TrackAndField_port_lg.jpg",
			"detail_trackField_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML/Flash"
		],
		"slug": "track-and-field-banner-campaign"
	},
	{
		"name": "DDR Banner Campaign",
		"client": "Konami",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 13,
		"featured": false,
		"src": [
			"dance_revolution_port_lg.jpg",
			"detail_ddr_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML/Flash"
		],
		"slug": "ddr-banner-campaign"
	},
	{
		"name": "Hummer Press Pass Video Campaign",
		"client": "ESPN.com",
		"alt": "",
		"website": "",
		"body": "ESPN hired Label to create 8 unique contest entry \"experiences\" based on multiple themes, ie. College Football Spring Practice, NBA Draft, NFL Training Camp, etc. The videos includes first person, 3D perspective visuals and custom sound design.",
		"id": 14,
		"featured": false,
		"src": [
			"ESPN_hummer_hero.jpg",
			"detail_hummer_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"Motion Design",
			"HTML Development"
		],
		"slug": "hummer-press-pass-video-campaign"
	},
	{
		"name": "Elebits Web Development",
		"client": "Konami",
		"alt": "",
		"website": "",
		"body": "Label worked with Konami to design and develop a microsite for the launch of their Wii console game, <i>Elebits</i>. Using design assets from the actual video game, the website included game footage and purchasing information.",
		"id": 15,
		"featured": false,
		"src": [
			"elebits_port_lg.jpg",
			"detail_elebits-microsite_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML/Flash"
		],
		"slug": "elebits-web-development"
	},
	{
		"name": "Game Table",
		"client": "Label Interactive",
		"alt": "",
		"website": "",
		"body": "A Label Interactive original! \n\nGame Table provides everything you need to play classic board and card games with your friends and family using the Apple iPad. Game Table gives you all the “virtual pieces” to play Checkers, Chess, Go, Reversi, and most card games without hunting for boards or missing pieces.\n\nGame Table debuted on the iTunes App Store as one of the top 5 paid apps when the iPad was first released in the US on April 3, 2010. \n\nSoon after its launch, Game Table became the NUMBER ONE iPad app on the iTunes App Store, beating Google Earth and Apple’s iBooks app.\n\n\n<i>“I think this is brilliant. You can never lose pieces, a strong wind cannot scatter chessmen when you play in the park, and as long as you have your iPad with you, you also have your chess set.” – Wired.com</i>",
		"id": 16,
		"featured": true,
		"src": [
			"game-table.jpg",
			"detail_gametable_02.jpg"
		],
		"type": [
			"Apps",
			"All"
		],
		"bullets": [
			"Design",
			"Native iOS development",
			"App Store Publishing"
		],
		"slug": "game-table"
	},
	{
		"name": "Aliens vs. Predator Microsite",
		"alt": "Sega",
		"website": "",
		"body": "Label designed and built a one-stop portal site for the Aliens Universe range of games. This project included a custom built CMS and integrated video, text and forum content from other Sega web properties.",
		"id": 17,
		"featured": false,
		"src": [
			"avp_port_lg.jpg",
			"detail_alien_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML/CSS/PHP",
			"Enterprise System Integration",
			"Customer CMS",
			"Language Localization"
		],
		"slug": "aliens-vs-predator-microsite"
	},
	{
		"name": "Allstate Field Goal Challenge",
		"client": "ESPN.com",
		"alt": "",
		"website": "",
		"body": "Created with all original design and sound assets, Label developed this web based action game for ESPN.com.  The game challenged the user to kick the best field goal for prizes.",
		"id": 18,
		"featured": false,
		"src": [
			"ESPN_field_goal_port_lg.jpg",
			"detail_allstate_02.jpg"
		],
		"type": [
			"Games",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"3D Modeling",
			"Sound design",
			"HTML/Flash"
		],
		"slug": "allstate-field-goal-challenge"
	},
	{
		"name": "Bayonetta Microsite",
		"alt": "Bayonetta Microsite Project Picture.",
		"website": "",
		"body": "Design and develop a microsite for Sega’s spectacular, fast-paced combat title. The site was designed to showcase the artwork and gameplay and customized to deliver video and blog content from Sega’s existing content management system.",
		"id": 19,
		"featured": false,
		"src": [
			"bayo_port_lg.jpg",
			"detail_bayonetta_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"client": "Sega",
		"bullets": [
			"Creative/Design",
			"Flash",
			"CMS Integration",
			"Language Localization"
		],
		"slug": "bayonetta-microsite"
	},
	{
		"name": "Killer Routine - User Generater Content contest",
		"client": "MTV Games",
		"alt": "",
		"website": "",
		"body": "Label development this website for MTV Games and Truth to launch a new console game, <i>Dance Central</i>. Users uploaded videos of themselves dancing and edited them using in-game footage and graphic overlays to create their own thirty second sequence. The site included a full-featured online video editor, text-message and email alerts, user voting and an admin approval system.",
		"id": 20,
		"featured": false,
		"src": [
			"KillerRoutine_port_lg.jpg",
			"detail_killer_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"HTML/CSS",
			"Javascript",
			"Flash based video editor"
		],
		"slug": "killer-routine-user-generater-content-contest"
	},
	{
		"name": "Champs Ultimate Training Camp Challenge",
		"client": "ESPN.com",
		"alt": "",
		"website": "",
		"body": "Label worked with ESPN.com to design and develop this promotional website. This microsite allowed visitors to enter a sweepstakes contest. ",
		"id": 21,
		"featured": false,
		"src": [
			"ESPN_champs_port_lg.jpg",
			"detail_champs_02.jpg"
		],
		"type": [
			"Games",
			"All"
		],
		"bullets": [
			"Design",
			"HTML Development"
		],
		"slug": "champs-ultimate-training-camp-challenge"
	},
	{
		"name": "The Closer Hot Seat Game",
		"client": "Turner",
		"alt": "",
		"website": "",
		"body": "Get in the hot seat!  This web app allows users to insert themselves in a scene of the popular Turner show, The Closer! After uploading their picture, the user could pan and zoom to make their face fit perfectly into the scene. Once they were done, they could share the new scene with their friends via Facebook and Twitter.",
		"id": 22,
		"featured": false,
		"src": [
			"closer_hotSeat_port_lg.jpg",
			"detail_closer-game_02.jpg"
		],
		"type": [
			"Games",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML/Flash",
			"PHP"
		],
		"slug": "the-closer-hot-seat-game"
	},
	{
		"name": "Energizer Overdrive Website Development",
		"client": "MTV Games",
		"alt": "",
		"website": "",
		"body": "Label designed & developed a content-managed, promotional microsite.",
		"id": 23,
		"featured": false,
		"src": [
			"energizer_overdrive_port_lg.jpg",
			"detail_energizer_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"Drupal",
			"HTML/CSS",
			"Flash"
		],
		"slug": "energizer-overdrive-website-development"
	},
	{
		"name": "The Closer Banner Campaign",
		"client": "Turner/TNT",
		"alt": "",
		"website": "",
		"body": " At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 24,
		"featured": false,
		"src": [
			"closer_port_lg.jpg",
			"detail_closer-banner_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"Rich Media",
			"Flash"
		],
		"slug": "the-closer-banner-campaign"
	},
	{
		"name": "Hawthorne Banner Campaign",
		"client": "Turner",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 25,
		"featured": false,
		"src": [
			"hawthorne_port_lg.jpg",
			"detail_hawthorne_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Design",
			"Banner Development"
		],
		"slug": "hawthorne-banner-campaign"
	},
	{
		"name": "Time Hollow Banner Campaign",
		"client": "Konami",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 27,
		"featured": false,
		"src": [
			"timehollow_port_lg.jpg",
			"detail_timehollow_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML/Flash"
		],
		"slug": "time-hollow-banner-campaign"
	},
	{
		"name": "Elebits Underwater Game Development",
		"client": "Konami",
		"alt": "",
		"website": "",
		"body": "Design and develop a promotional game and micro site using assets from the Elebits Wii game.",
		"id": 28,
		"featured": false,
		"src": [
			"elebits_uw_port_lg.jpg",
			"detail_elebitz_02.jpg"
		],
		"type": [
			"Games",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML/Flash"
		],
		"slug": "elebits-underwater-game-development"
	},
	{
		"name": "NHL Sustainability Report",
		"client": "NHL",
		"alt": "",
		"website": "http://ice.nhl.com/green/report/",
		"body": "We’re proud to have recently produced this site for the NHL. It’s only one page but there’s a ton of (really good) information, HTML5 animation and parallax scrolling effects. It’s also a responsive webpage, meaning the page will automatically optimize itself for desktop, tablet and mobile screens.",
		"id": 30,
		"featured": true,
		"src": [
			"nhl_small.jpg",
			"detail_nhl_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"Responsive Design & Development",
			"Parallax Scrolling Effects",
			"HTML5 Animated Charts & Graphs"
		],
		"slug": "nhl-sustainability-report"
	},
	{
		"name": "Kia Tip Off Challenge Banner Campaign",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 31,
		"featured": false,
		"src": [
			"ESPN_kia_port_lg.jpg",
			"detail_kia_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Design",
			"Banner Development"
		],
		"slug": "kia-tip-off-challenge-banner-campaign"
	},
	{
		"name": "Meet the Browns Banner Campaign",
		"client": "Turner",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 32,
		"featured": false,
		"src": [
			"mtb_port_lg.jpg",
			"detail_meetthebrowns_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Rich media banners and takeovers",
			"Standard Flash banners"
		],
		"slug": "meet-the-browns-banner-campaign"
	},
	{
		"name": "Silent Hill Shattered Memories Microsite",
		"client": "Konami",
		"alt": "",
		"website": "",
		"body": "Label designed and developed a teaser blog and full site for the newest game in Konami’s popular Silent Hill series. The site was built to showcase the mood and gameplay of the console title while integrating game-specific blog and forum content.",
		"id": 33,
		"featured": true,
		"src": [
			"shsm_port_lg.jpg",
			"detail_silenthill_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"Creative/Design",
			"HTML/Flash"
		],
		"slug": "silent-hill-shattered-memories-microsite"
	},
	{
		"name": "Are We There Yet Banner Campaign",
		"client": "Turner",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 34,
		"featured": true,
		"src": [
			"AWTY_port_lg.jpg",
			"detail_awty_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Design",
			"Banner Development"
		],
		"slug": "are-we-there-yet-banner-campaign"
	},
	{
		"name": "Nivea 100 Year Sweepstakes Microsite",
		"client": "Black Diamond Media",
		"alt": "",
		"website": "",
		"body": "Nivea celebrated their 100th anniversary with a sweepstakes. Special codes printed on-pack gave users a chance to enter the sweepstakes for a trip to see Rihanna perform live in Prague. We built a microsite that allowed users to enter their codes, confirm their sweeps entry and access special content. We also architected a solution to handle bursts of traffic each time Rihanna (who has over 70M followers!) tweeted and posted special codes on Facebook.",
		"id": 35,
		"featured": true,
		"src": [
			"detail_nivea_01.jpg",
			"detail_nivea_02.jpg"
		],
		"type": [
			"Web",
			"All"
		],
		"bullets": [
			"HTML/CSS",
			"PHP",
			"Custom real-time analytics"
		],
		"slug": "nivea-100-year-sweepstakes-microsite"
	},
	{
		"name": "Magician’s Quest Banner Campaign",
		"client": "Konami",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 36,
		"featured": false,
		"src": [
			"magicQuest_port_lg.jpg",
			"detail_magicians_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Design",
			"Banner Development"
		],
		"slug": "magician-s-quest-banner-campaign"
	},
	{
		"name": "Saving Grace Banner Campaign",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 37,
		"featured": false,
		"src": [
			"saving_grace_port_lg.jpg",
			"detail_savinggrace_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Design",
			"Banner Development"
		],
		"slug": "saving-grace-banner-campaign"
	},
	{
		"name": "Lenovo Banner Campaign",
		"client": "ESPN.com",
		"alt": "",
		"id": 39,
		"website": "",
		"body": " At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"featured": false,
		"src": [
			"ESPN_lenova_port_lg.jpg",
			"detail_lenovo_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Design",
			"Banner Development"
		],
		"": "",
		"slug": "lenovo-banner-campaign"
	},
	{
		"name": "Lopez Tonight Banner Campaign",
		"alt": "",
		"website": "",
		"body": "At Label, we design and develop hundreds of banner ad campaings each year. Our banner capabilities include static ads, HTML5 animation, rich media, and speciality ad units such push-downs and takeovers. We also produce static and video banners for social media networks such as Snapchat, Instagram, and Facebook.",
		"id": 40,
		"featured": false,
		"src": [
			"lopez_tonight_port_lg.jpg",
			"detail_lopez_02.jpg"
		],
		"type": [
			"Banners",
			"All"
		],
		"bullets": [
			"Design",
			"Banner Development"
		],
		"slug": "lopez-tonight-banner-campaign"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/projects.json
// module id = 563
// module chunks = 2